<template>
  <v-alert
    type="warning"
    icon="warning"
    color="#fb8c00"
    outlined
    border="left"
    max-width="640"
    class="NotLinkedProfileAlert"
  >
    <div>
      This child profile is NOT linked to a parent account.
      Having a linked profile allows you to access more content and save progress.
      You can link a profile by copying the Child Profile ID
      <v-tooltip v-model="idCopied" top>
        <template v-slot:activator="{ on }">
          <span
            style="text-decoration: underline; cursor: pointer"
            @click="copyProfileID"
          >here</span>
        </template>

        <span>ID: {{ id }} copied to clipboard</span>
      </v-tooltip>
      and entering it on the
      <a
        href="#"
        class="text-decoration-underline orange--text"
        @click.prevent="checkAccountPage"
      >
        account page
      </a>
      of the parent application.
    </div>
  </v-alert>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

const hrefChildren = 'https://growmindgrow.com/parent/account/children';

export default {
  name: 'NotLinkedProfileAlert',
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      idCopied: false,
    };
  },
  computed: {
    ...mapGetters({
      parentAccount: 'parent/parentAccount',
    }),
  },
  methods: {
    ...mapActions({
      setLogInModalState: 'setLogInModalState',
      setLogInModalCallback: 'setLogInModalCallback',
    }),
    copyProfileID() {
      this.$copyText(this.id);
      this.idCopied = true;

      setTimeout(() => (this.idCopied = false), 3000);
    },
    redirectToAccountChildren() {
      window.location = hrefChildren;
    },
    checkAccountPage() {
      if (!this.parentAccount || !this.parentAccount.jwt) {
        this.setLogInModalState(true);
        this.setLogInModalCallback(() => this.redirectToAccountChildren());
        return;
      }

      this.redirectToAccountChildren();
    },
  },
};
</script>
